<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>{{ header }} Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.toString() === 'All'" class="small font-weight-light grey--text">Note: All items are being selected.</div>
              <div v-if="checkedItems.toString() === ''" class="small font-weight-light grey--text">Note: No item is selected.</div>
              <v-textarea
                v-if="checkedItems.toString() !== 'All' && checkedItems.length > 0"
                label="Selected Items"
                v-model="checkedItems"
                rows="1"
                readonly
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn color="green" dark class=" mr-2" @click="doSelect('All', header)">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="red darken-1" dark class=" mr-2" @click.prevent="doDeselectAll('', header)">
                Deselect All
              <v-icon dark right>mdi-checkbox-multiple-blank-outline</v-icon></v-btn> -->
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', header)">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { helpListMixin } from '@/mixins/common/helpListMixin'

export default {
  props: {
    apiURI: String,
    mode: String,
    param: String
  },
  data() {
    return {
      headers: [
        { text: 'Branch', value: 'id' },
        { text: 'Description', value: 'desc' }
      ],
      header: '',
      selected: [],
      selectedItems: [],
      checkedItems: [],
      checkedItemsAll: [],
      parameter: [],
      items: [],
      paramItems: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    mode: function (value) {
      this.doInit()
      this.getLabel()
    }
  },
  created() {
    this.doInit()
    this.getLabel()
  },
  methods: {
    doInit() {
      this.parameter = this.param.split(',')
      const apiURI = this.apiURI
      if (apiURI) {
        if (this.parameter !== this.checkedItems) {
          this.doReset()
          this.checkedItems = this.parameter
        }
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            this.selectedItems = []
            const { data } = result.data
            if (data) {
              data.map((param) => {
                const convertList = {
                  key: param.value,
                  id: param.value,
                  desc: param.label
                }
                if (this.checkedItems.includes(param.value)) {
                  const branchList = {
                    key: param.value,
                    id: param.value,
                    desc: param.label
                  }
                  this.selectedItems.push(branchList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === '') {
              this.doReset()
            }
            if (this.selectedItems.length > 0) {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    getLabel() {
      this.headers = []
      // Add an empty for the checkbox
      this.headers.push({ text: '', value: 'id' })
      switch (this.mode) {
        case 'intermediary':
          this.headers.push({ text: 'Intermediary', value: 'id' })
          this.header = 'Intermediary'
          break
        default:
          this.header = ''
          break
      }
      this.headers.push({ text: 'Description', value: 'desc' })
    },
    doSelect(opt, caller) {
      let selectedObj = {}
      if (opt === 'All') {
        this.doReset()
        this.checkedItemsAll.push('All')
        selectedObj = {
          finalSelectedItems: this.checkedItemsAll
        }
      } else if (opt === '') {
        selectedObj = {
          finalSelectedItems: ''
        }
      }
      if (this.checkedItems.length > 0) {
        selectedObj = {
          finalSelectedItems: this.checkedItems
        }
      }
      this.$emit('doAssign', selectedObj)
      this.$emit('close', caller)
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
